var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1992 6C17.2092 6.00147 15.5986 7.61321 15.6001 9.59927C15.5986 11.5853 17.2107 13.1971 19.2007 13.1985H22.8013V9.60073C22.8027 7.61468 21.1907 6.00294 19.1992 6C19.2007 6 19.2007 6 19.1992 6V6ZM19.1992 15.6H9.60059C7.61056 15.6015 5.99853 17.2132 6 19.1993C5.99706 21.1853 7.60909 22.7971 9.59912 22.8H19.1992C21.1893 22.7985 22.8013 21.1868 22.7998 19.2007C22.8013 17.2132 21.1893 15.6015 19.1992 15.6Z",
    fill: "#36C5F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0001 19.1993C42.0016 17.2132 40.3895 15.6015 38.3995 15.6C36.4094 15.6015 34.7974 17.2132 34.7989 19.1993V22.8H38.3995C40.3895 22.7985 42.0016 21.1868 42.0001 19.1993ZM32.3999 19.1993V9.59927C32.4014 7.61468 30.7908 6.00294 28.8008 6C26.8108 6.00147 25.1987 7.61321 25.2002 9.59927V19.1993C25.1973 21.1853 26.8093 22.7971 28.7993 22.8C30.7894 22.7985 32.4014 21.1868 32.3999 19.1993Z",
    fill: "#2EB67D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7991 41.9998C30.7891 41.9984 32.4012 40.3866 32.3997 38.4006C32.4012 36.4145 30.7891 34.8028 28.7991 34.8013H25.1985V38.4006C25.197 40.3852 26.8091 41.9969 28.7991 41.9998ZM28.7991 32.3984H38.3992C40.3893 32.3969 42.0013 30.7852 41.9999 28.7991C42.0028 26.813 40.3908 25.2013 38.4007 25.1984H28.8006C26.8105 25.1998 25.1985 26.8116 25.2 28.7976C25.1985 30.7852 26.8091 32.3969 28.7991 32.3984Z",
    fill: "#ECB22E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 28.799C5.99853 30.7851 7.61056 32.3968 9.6006 32.3983C11.5906 32.3968 13.2027 30.7851 13.2012 28.799V25.1997H9.6006C7.61056 25.2012 5.99853 26.8129 6 28.799ZM15.6001 28.799V38.399C15.5972 40.3851 17.2092 41.9969 19.1993 41.9998C21.1893 41.9983 22.8013 40.3866 22.7999 38.4005V28.8019C22.8028 26.8159 21.1908 25.2041 19.2007 25.2012C17.2092 25.2012 15.5987 26.8129 15.6001 28.799C15.6001 28.8005 15.6001 28.799 15.6001 28.799Z",
    fill: "#E01E5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/Slack.93f7e820.svg";
export { ForwardRef as ReactComponent };